export default {
    state: {
        step: 'searchCatalogue',
        tab: 'assureur',
        objet:{}
    },
    mutations: {
        setStep(state, paylaod) {
            state.step = paylaod.step
        },
        setObjet(state, paylaod) {
            state.objet = paylaod.objet
        },
        setTab(state, paylaod) {
            state.tab = paylaod.tab
        }
    },
    actions: {},
    getters: {
        getStep(state) {
            return state.step
        },
        getObjet(state) {
            return state.objet
        },
        getTab(state) {
            return state.tab
        },
    },
}
